import React, { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import api from '../../services/api';

export default function CaptureImageModal({ capture, onClose }) {
  const [source, setSource] = useState(capture.tem_imagem_completa ? null : capture.imagem);
  const [error, setError] = useState('');
  const closeButton = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButton.current?.focus();
    const key = event => {
      if (event.key === 'Escape') onCloseRef.current();
      if (event.key === 'Tab') { event.preventDefault(); closeButton.current?.focus(); }
    };
    document.addEventListener('keydown', key);
    return () => { document.body.style.overflow = previousOverflow; document.removeEventListener('keydown', key); previousFocus?.focus(); };
  }, []);
  useEffect(() => {
    if (!capture.tem_imagem_completa) return;
    let active = true;
    let objectUrl;
    const controller = new AbortController();
    api.get(`/controle-acesso/capturas/${capture.id}/imagem-completa`, { responseType: 'blob', signal: controller.signal })
      .then(({ data }) => { if (active) { objectUrl = URL.createObjectURL(data); setSource(objectUrl); } })
      .catch(() => { if (active) setError('Não foi possível carregar a imagem completa. Feche e tente novamente.'); });
    return () => { active = false; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [capture.id, capture.tem_imagem_completa]);
  return <div role="dialog" aria-modal="true" aria-label="Imagem completa da captura" className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 p-4 backdrop-blur-sm" onClick={onClose}>
    <button ref={closeButton} type="button" aria-label="Fechar imagem completa" onClick={onClose} className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white hover:bg-white/20"><X size={24} /></button>
    <div className="max-w-[95vw] text-center" onClick={event => event.stopPropagation()}>
      <p className="mb-3 text-sm text-white">{capture.camera_nome} · {new Date(capture.capturado_em).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</p>
      {source && <img src={source} alt={`Imagem do momento da captura em ${capture.camera_nome}`} className="mx-auto max-h-[80vh] max-w-full rounded-xl object-contain shadow-2xl" />}
      {!source && !error && <p role="status" className="p-8 text-white">Carregando imagem completa...</p>}
      {error && <p role="alert" className="p-8 text-white">{error}</p>}
      {!capture.tem_imagem_completa && <p className="mt-3 text-sm text-amber-200">Esta captura antiga possui apenas o recorte. A imagem completa será salva nas novas capturas.</p>}
    </div>
  </div>;
}
